import React from 'react';
import PanettoneQuotaSellers from 'components/Tvendo/Sale/QuotaBPartner/WinterCuotas/Panettone/QuotaSellers/List.js';

export default function () {
  return <PanettoneQuotaSellers />;
}
